import { DiProcess, getCurrentBucket, targetingService, utils } from 'src/core';

const logGroup = 'ExperimentBucketReporter';

export class ExperimentBucketReporterSetup implements DiProcess {
	execute(): void {
		this.configure();
	}

	private configure(): void {
		const bucket = getCurrentBucket();

		if (!bucket || bucket === '100') {
			utils.logger(logGroup, 'No experiment bucket found');
			return;
		}

		this.addBucketToTargeting(bucket);
		utils.logger(logGroup, `Experiment bucket ${bucket}`);
	}

	private addBucketToTargeting(bucket: string): void {
		targetingService.set('exp_bucket', bucket);
	}
}
